import StorageRolesInfoTab from "../Tabs/storageRoles/InfoTab";
import StorageRolesDevicesTab from "../Tabs/storageRoles/DevicesTab";
import StorageRolesBillsTab from "../Tabs/storageRoles/BillsTab";
import StorageRolesProductSettingsTab from "../Tabs/storageRoles/ProductSettingsTab";
import UsersWithTemplatesTab from "../Tabs/storageRoles/UsersWithTemplatesTab";
import SubFirmsTab from "../Tabs/storageRoles/SubFirmsTab";
import StorageCustomersTab from "../Tabs/storageRoles/CustomersTab";
import StatsTab from "../Tabs/storageRoles/StatsTab";
import ReportTab from "../Tabs/storageRoles/ReportTab";
import EmployeesWithTemplatesTab from "../Tabs/storageRoles/EmployeesWithTemplatesTab";

export default function StorageRolesFirmTabContent({
  selectedTab,
  firm,
  readOnly,
  onFirmUpdate,
  onNavigateToFirm,
  onOpenReportSettings,
}) {
  return (
    <div className="flex-1 min-h-0 overflow-hidden">
      {selectedTab === "info" && (
        <div className="h-full bg-gray-50/40">
          <StorageRolesInfoTab
            firm={firm}
            readOnly={readOnly}
            onFirmUpdate={onFirmUpdate}
            onSelectedFirm={onNavigateToFirm}
            onOpenReportSettings={onOpenReportSettings}
          />
        </div>
      )}
      {selectedTab === "devices" && (
        <div className="h-full">
          <StorageRolesDevicesTab firm={firm} readOnly={readOnly} />
        </div>
      )}
      {selectedTab === "productSettings" && (
        <div className="h-full">
          <StorageRolesProductSettingsTab firm={firm} readOnly={readOnly} />
        </div>
      )}
      {selectedTab === "bills" && (
        <div className="h-full">
          <StorageRolesBillsTab firm={firm} readOnly={readOnly} />
        </div>
      )}
      {selectedTab === "subfirms" && (
        <div className="h-full">
          {/* Bayide alt bayiler + müşteriler tek sekmede (#376) */}
          {firm?.firmType === "dealer" ? (
            <StorageCustomersTab onSelectedFirm={onNavigateToFirm} firm={firm} />
          ) : (
            <SubFirmsTab onSelectedFirm={onNavigateToFirm} firm={firm} />
          )}
        </div>
      )}
      {selectedTab === "users" && (
        <div className="h-full">
          {/* Kullanıcılar + kullanıcı şablonları tek sekmede (#298) */}
          <UsersWithTemplatesTab firm={firm} readOnly={readOnly} />
        </div>
      )}
      {selectedTab === "stats" && (
        <div className="h-full">
          <StatsTab firm={firm} />
        </div>
      )}
      {selectedTab === "reports" && (
        <div className="h-full">
          <ReportTab firm={firm} />
        </div>
      )}
      {selectedTab === "employees" && (firm?.firmType === "customer") && (
        <div className="h-full">
          {/* Çalışanlar + çalışan şablonları tek sekmede (#298) */}
          <EmployeesWithTemplatesTab firm={firm} readOnly={readOnly} />
        </div>
      )}
    </div>
  );
}
